// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/reports/accounting/journal-entries',
        component: () =>
            import('@/pages/[organisation]/reports/accounting/journal-entries.vue'),
        name: 'reports.accounting.journal-entries',
        meta: {
            loginRequired: true,
            permission: 'access.reports.accounting.generate-journal-entries-report',
        },
    },
    {
        path: '/:organisation/reports/accounting/account-transactions/:id',
        component: () =>
            import('@/pages/[organisation]/reports/accounting/account-transactions/[id].vue'),
        name: 'reports.accounting.account-transactions',
        meta: {
            loginRequired: true,
            permission: 'access.reports.accounting.generate-journal-entries-report',
        },
    },
];
